import { render, staticRenderFns } from "./flowNewsAuditForm.vue?vue&type=template&id=6df527b7&"
import script from "./flowNewsAuditForm.vue?vue&type=script&lang=js&"
export * from "./flowNewsAuditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports